import { render, staticRenderFns } from "./DetalleConsulta.vue?vue&type=template&id=3614a3c5&"
import script from "./DetalleConsulta.vue?vue&type=script&lang=js&"
export * from "./DetalleConsulta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports